<div class="offline-toolbar-margin">
</div>
<div class="offline-toolbar">
  <span translate>SERVER-OFFLINE</span>
</div>
<div class="offline-toolbar-margin">
</div>

